import { useAuth } from "@/lib/auth";
import { ListTodo, Calendar } from "lucide-react";
import { usePlanner } from "../contexts/PlannerContext";
import { AnimatePresence, motion } from "framer-motion";

export const LimitTracker = () => {
    const { planType } = useAuth();
    const { weeklyUsage: usage, usageLoading: loading } = usePlanner();

    const getDisplayText = () => {
        if (!usage) return "";

        if (usage.current_usage === 0) {
            return <p>Nothing planned this week. <strong>Drag</strong> an assignment to plan it!</p>
        }

        if (usage.current_usage >= usage.max_limit) {
            return <p>All {usage.max_limit} planning spots used this week. Upgrade to plan unlimited spots!</p>
        }

        return <p><strong>{usage.current_usage} of {usage.max_limit}</strong> planning spots used this week.</p>

    }



    const shouldShow = usage && !loading && !(planType === 'pro' && (usage?.current_usage ?? 0) > 0);

    return (
        <AnimatePresence>
            {shouldShow && (
                <motion.div
                    key="limit-tracker"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.2 }}
                    className="fixed z-30 bottom-2 left-0 w-full pointer-events-none flex items-center justify-center"
                >
                    <div className="border border-theme backdrop-blur-sm rounded-xl px-4 py-2.5 text-xs bg-theme-0 pointer-events-auto">
                        <div className="text-theme-0 font-medium flex items-center gap-1.5">
                            <Calendar className="size-3.5 text-theme-0/60" />
                            {getDisplayText()}
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};